import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzInputModule } from 'ng-zorro-antd/input';
import { TranslatePipe } from '@ngx-translate/core';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { InlineInputControlComponent } from '../inline-input-control/inline-input-control.component';

interface CheckInputValue {
  enabled: boolean;
  value: string | undefined;
}

@Component({
  selector: 'moxi-check-input-control',
  imports: [
    FormsModule,

    InlineInputControlComponent,

    TranslatePipe,

    // Ant Design
    NzGridModule,
    NzInputModule,
    NzCheckboxModule,
    NzInputNumberModule
  ],
  templateUrl: './check-input-control.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckInputControlComponent),
      multi: true
    }
  ]
})
export class CheckInputControlComponent implements ControlValueAccessor {
  label = input.required<string>();
  inputWidth = input('100%');
  isNumber = input(false);
  maxValue = input<number | undefined>();
  minValue = input<number | undefined>();

  value: CheckInputValue = { enabled: false, value: undefined };

  onChange: (value: CheckInputValue) => void = () => undefined;
  onTouched: () => void = () => undefined;

  writeValue(value: CheckInputValue): void {
    if (value) {
      this.value = value;
    }
  }

  registerOnChange(fn: (value: CheckInputValue) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onCheckboxChange(checked: boolean): void {
    this.value = { ...this.value, enabled: checked };
    this.onChange(this.value);
  }

  onTextChange(text: string): void {
    this.value = { ...this.value, value: text };
    this.onChange(this.value);
  }
}
